export default __webpack_public_path__ + "static/media/6.3c5bf43f.svg";